// Mock data for RentMyRO website

export const companyInfo = {
  name: "RentMyRO Water Tech Pvt. Ltd.",
  tagline: "Pure Water, Healthy Life",
  phone: "+91 96677 66403",
  email: "rentmyro@gmail.com",
  whatsapp: "+919667766403",
  address: "356/87, Hanuman Mandir Marg, Block H, Ashok Vihar Phase 2, Haryana 122006",
  location: {
    lat: 28.48849,
    lng: 77.01657
  }
};

export const heroContent = {
  title: "Premium RO Water Purifiers on Rent",
  subtitle: "Affordable, Hassle-Free Water Solutions for Homes, Offices & Commercial Spaces",
  description: "Get pure, safe drinking water without the upfront cost. Flexible rental plans starting from ₹499/month with free installation, maintenance & AMC included.",
  ctaText: "Get RO on Rent Today",
  ctaSecondary: "Check Water Quality"
};

export const services = [
  {
    id: 1,
    icon: "Droplets",
    title: "RO on Rent for Homes",
    description: "Affordable monthly rental plans for residential RO water purifiers. No upfront cost, free installation and regular maintenance included.",
    features: ["Free Installation", "Monthly Maintenance", "24/7 Support", "No Deposit"]
  },
  {
    id: 2,
    icon: "Building2",
    title: "Corporate & Office Solutions",
    description: "Customized water purification systems for offices and corporate spaces. Ensure pure water for your entire team with hassle-free service.",
    features: ["Bulk Capacity", "AMC Plans", "Quick Service", "Professional Setup"]
  },
  {
    id: 3,
    icon: "School",
    title: "Schools & Institutions",
    description: "Safe drinking water solutions for educational institutions, hospitals and community spaces with high capacity purification systems.",
    features: ["High Capacity", "Safety Certified", "Regular Testing", "Maintenance Plans"]
  },
  {
    id: 4,
    icon: "Factory",
    title: "Industrial Water Treatment",
    description: "Advanced water purification and treatment solutions for industries, manufacturing units and large commercial establishments.",
    features: ["Custom Solutions", "Industrial Grade", "Process Water", "Expert Team"]
  },
  {
    id: 5,
    icon: "Wrench",
    title: "Installation & Maintenance",
    description: "Professional RO installation, repair and maintenance services. Regular AMC plans to keep your purifier running efficiently.",
    features: ["Expert Technicians", "Genuine Parts", "Same Day Service", "Annual Plans"]
  },
  {
    id: 6,
    icon: "FlaskConical",
    title: "Water Quality Testing",
    description: "Comprehensive water quality analysis and testing services. Know what's in your water with detailed TDS and contamination reports.",
    features: ["Lab Testing", "TDS Analysis", "Report & Certification", "Consultation"]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "IndianRupee",
    title: "Affordable Plans",
    description: "Flexible monthly rental plans starting from just ₹499. No heavy upfront investment required."
  },
  {
    id: 2,
    icon: "Zap",
    title: "Quick Installation",
    description: "Same day installation service across Gurgaon. Get your RO up and running within 24 hours."
  },
  {
    id: 3,
    icon: "Shield",
    title: "100% Pure Water",
    description: "Advanced multi-stage purification technology ensuring TDS-controlled, safe drinking water."
  },
  {
    id: 4,
    icon: "Users",
    title: "Expert Team",
    description: "Certified technicians with 10+ years of experience in water purification solutions."
  },
  {
    id: 5,
    icon: "Wrench",
    title: "Free Maintenance",
    description: "Regular maintenance and filter changes included in rental. No hidden charges."
  },
  {
    id: 6,
    icon: "Clock",
    title: "24/7 Support",
    description: "Round-the-clock customer support for any queries or emergency service requirements."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Homeowner, DLF Phase 2",
    content: "Excellent service! The RO rental plan is so affordable and the water quality is outstanding. Highly recommend RentMyRO.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Office Manager, Cyber City",
    content: "We've been using their corporate plan for 2 years. Maintenance is always on time and the team is very professional.",
    rating: 5
  },
  {
    id: 3,
    name: "Dr. Amit Verma",
    role: "Principal, Green Valley School",
    content: "Safe drinking water for our 500+ students. Their high-capacity systems work flawlessly. Great service!",
    rating: 5
  }
];

export const stats = [
  { number: "5+", label: "Years Experience" },
  { number: "5000+", label: "Happy Customers" },
  { number: "50+", label: "Corporate Clients" },
  { number: "24/7", label: "Support Available" }
];

export const certifications = [
  "ISO 9001:2015 Certified",
  "Water Quality Association Member",
  "BIS Approved Products",
  "Environmental Compliance"
];

// Mock function to simulate form submission
export const submitEnquiry = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Store in localStorage for demo
  const enquiries = JSON.parse(localStorage.getItem('enquiries') || '[]');
  const newEnquiry = {
    id: Date.now(),
    ...formData,
    timestamp: new Date().toISOString()
  };
  enquiries.push(newEnquiry);
  localStorage.setItem('enquiries', JSON.stringify(enquiries));
  
  return { success: true, message: "Thank you! We'll contact you shortly." };
};
